import Mobile from './components/mobile.vue'; 
import Welcome from './components/welcome.vue'; 
import Plains from './components/plains.vue'; 
import Ocean from './components/ocean.vue'; 
import Amazon from './components/amazon.vue'; 
import Forest from './components/forest.vue'; 
import Desert from './components/desert.vue'; 
import Beach from './components/beach.vue'; 
import NYC from './components/nyc.vue'; 
import Rural from './components/rural.vue'; 
import Ice from './components/ice.vue'; 
import Fire from './components/fire.vue'; 
import Tutorial from './components/tutorial.vue'; 

export const routes = [
	{name: 'welcome', path: '/', component: Welcome,  meta:{title:'Soundscape.cloud'}},
	{name: 'mobile', path: '/mobile', component: Mobile,  meta:{title:'Soundscape.cloud'}},
	{name: 'plains', path: '/grasslands', component: Plains,  meta:{title:'Grasslands'}},
	{name: 'ocean', path: '/ocean', component: Ocean,  meta:{title:'Pacific Ocean'}},
	{name: 'amazon', path: '/amazon', component: Amazon,  meta:{title:'Amazon Rainforest'}},
	{name: 'forest', path: '/woodlands', component: Forest,  meta:{title:'Deciduous Forest'}},
	{name: 'desert', path: '/desert', component: Desert, meta:{title:'Mojave Desert'}},
	{name: 'beach', path: '/seaside', component: Beach,  meta:{title:'Beach Vibes'}},
	{name: 'nyc', path: '/nyc', component: NYC,  meta:{title:'New York City'}},
	{name: 'rural', path: '/smalltown', component: Rural,  meta:{title:'Small Town'}},
	{name: 'Ice', path: '/ice', component: Ice,  meta:{title:'Subzero Sounds'}},
	{name: 'Fire', path: '/fire', component: Fire,  meta:{title:'Sizzling Sounds'}},
	{name: 'tutorial', path: '/tutorial', component: Tutorial,  meta:{title:'Tutorial'}}
]; 


// WEBPACK FOOTER //
// ./src/routes.js